export enum ApplicationUserRole {
  ApplicationUser = 1,
  ApplicationAdministrator = 512,
}
